<template>
  <div>
    <ViewHeader :account-id="accountId" :project-id="projectId" />
    <div class="p-8">
      <div class="max-w-7xl mx-auto">
        <SmsCampaignList :account-id="accountId" :project-id="projectId" />
      </div>
    </div>
  </div>
</template>

<script>
import ViewHeader from './components/ViewHeader.vue';
import SmsCampaignList from '@/components/SmsCampaign/SmsCampaignList/SmsCampaignList.vue';

export default {
  components: {
    ViewHeader,
    SmsCampaignList,
  },
  props: {
    accountId: {
      type: String,
      required: true,
    },
    projectId: {
      type: String,
      default: null,
    },
  },
};
</script>
